ACC.checkoutB2B = {
    cartData: "",
    PaymentType: function () {


        if ($(".summaryPaymentType").length > 0) {
            var $element = $(".summaryPaymentType");
            var config = $element.data();


            $(".summaryPaymentType input[name='PaymentType']").on("change", function () {
                $.postJSON(config.setPaymentTypeUrl, {paymentType: $(this).val()}, function (data) {
                    ACC.checkoutB2B.refresh(data);
                    $(".summary-section").removeClass("complete");
                    $(".summaryPaymentType").addClass("complete");
                    $(".summaryCostCenter .constCenterSelect").val("")

                });
                var globalMessage = document.getElementById("globalMessages");
                while (globalMessage.firstChild) {
                    globalMessage.removeChild(globalMessage.firstChild);
                }
            });


            $("#PurchaseOrderNumber").on("blur", function () {

                $.postJSON(config.setPurchaseOrderNumberUrl, {purchaseOrderNumber: $(this).val()}, function (data) {
                    ACC.checkoutB2B.refresh(data);
                });

            })

        }

    },

    PaymentMode: function () {


        if ($(".summaryPaymentMode").length > 0) {
            var $element = $(".summaryPaymentMode");
            var config = $element.data();


            $(".summaryPaymentMode input[name='PaymentMode']").on("change", function () {
                $.postJSON(config.setPaymentModeUrl, {paymentMode: $(this).val()}, function (data) {
                    ACC.checkoutB2B.refresh(data);
                    $(".summaryPaymentMode").addClass("complete")
                    if (data.paymentMode.hint) {
                        $("#payment-hint").text(data.paymentMode.hint);
                        $("#payment-hint").removeClass("hide");
                        $("#payment-hint-default").addClass("hide");
                    } else {
                        $("#payment-hint-default").removeClass("hide");
                        $("#payment-hint").addClass("hide");
                    }
                });
            })

        }


    },

    costCenter: function () {
        if ($(".summaryCostCenter").length > 0) {
            var config = $(".summaryCostCenter").data();
            $(".summaryCostCenter .constCenterSelect").on("change", function () {
                if ($(this).val() != "") {
                    $.postJSON(config.setCostCenterUrl, {costCenterId: $(this).val()}, function (data) {
                        ACC.checkoutB2B.refresh(data);
                        $(".summaryCostCenter").addClass("complete")
                    });
                } else {
                    $(".summaryCostCenter").removeClass("complete")
                }
            })
        }

    },

    payment: function () {

        $(document).ready(function () {
            $("#securityCode").val("");
        });

        $(document).on("focusout", '.summaryPayment #SecurityCodePayment', function (e) {
            $("#securityCode").val($(this).val())
        });


        $(document).on("click", '.summaryPayment .security_code_what', function (e) {
            $('.security_code_what').bt($(".summaryPayment").data('security-what-text'), {
                trigger: 'click',
                positions: 'bottom',
                fill: '#efefef',
                cssStyles: {
                    fontSize: '11px'
                }
            });
        });

        $(document).on("click", '.js-delete-payment-info', function () {
            var $deleteButton = $(this);
            var url = $deleteButton.data('url');
            var paymentId = $deleteButton.data('payment');

            $.postJSON(url, {paymentId: paymentId}, function (data) {
                ACC.checkoutB2B.refresh(data);
            });
        });


        $(document).on("change", '#differentAddress', function () {
            var newAddress = $('#differentAddress').attr("checked");
            if (newAddress) {
                $("#newBillingAddressFields :input").removeAttr('disabled');
            }
            else {
                $("#newBillingAddressFields :input").attr('disabled', 'disabled');
            }
        });

    },
    deliveryAddress: function (section) {

        $(document).on("click", '#summaryDeliveryAddressOverlay #summaryOverlayViewAddressBook', function () {
            $("#summaryDeliveryAddressBook").show();
            $("#summaryDeliveryAddressForm").hide();
            $.colorbox.resize();
        });

        $(document).on("click", '.summaryDeliveryAddress .editButton', function () {

            var openColorBox = function () {
                $.colorbox({
                    inline: true,
                    href: "#summaryDeliveryAddressOverlay",
                    height: false,
                    innerWidth: "890px",
                    onLoad: function () {
                        $('#cboxClose').remove();
                    },
                    onComplete: function () {
                        ACC.common.refreshScreenReaderBuffer();
                        ACC.checkoutB2B.validateDeliveryAddressPopUp();
                        $.colorbox.resize();
                    },
                    onCleanup: function () {
                        KMVP.regionalassortment.addressChangeCleanup()
                    },
                    onClosed: function () {
                        ACC.common.refreshScreenReaderBuffer();
                    }
                });
            };

            if (ACC.checkoutB2B.cartData.paymentType.code == "ACCOUNT") {
                var changeFormUrl = $(this).closest(".js-summaryDeliveryAddress").data('get-form') + "?createUpdateStatus=1&addressId=";
            } else {
                var changeFormUrl = $(this).closest(".js-summaryDeliveryAddress").data('get-form') + "?createUpdateStatus=1&addressId=" + $(this).data("address");
            }

            var getUrl = $(this).closest(".js-summaryDeliveryAddress").data('get');

            ACC.checkoutB2B.showAddressForm(changeFormUrl, getUrl, openColorBox, true);
        });


        $(document).on("click", '#summaryDeliveryAddressOverlay .useAddress', function (e) {
            e.preventDefault();
            var addressId = $(this).data('address');
            $.postJSON($('.summaryDeliveryAddress').data("set"), {addressId: addressId}, function (data) {
                ACC.checkoutB2B.refresh(data);
                $.colorbox.close();
            });

        });


        $(document).on("click", '#summaryDeliveryAddressOverlay #addressForm button', function () {
            var saveAddressChecked = $(this).prop('checked');
            $('#defaultAddress').prop('disabled', !saveAddressChecked);
            if (!saveAddressChecked) {
                $('#defaultAddress').prop('checked', false);
            }
        });


        $(document).on("click", '#summaryDeliveryAddressBook .addressEntry .edit', function (e) {
            e.preventDefault();

            var changeFormUrl = $(this).closest(".js-summaryDeliveryAddress").data('get-form') + "?createUpdateStatus=1&addressId=" + $(this).data("address");
            $.get(changeFormUrl, function (data) {

                $("#summaryDeliveryAddressForm").remove();
                $("#summaryDeliveryAddressOverlay").prepend(data);
                $("#summaryDeliveryAddressBook").hide();
                $("#summaryDeliveryAddressForm").show();
                $.colorbox.resize();

            });
        });


        $(document).on("click", '#summaryDeliveryAddressOverlay button.default', function (e) {
            e.preventDefault();
            var addressId = $(this).data('address');
            $.postJSON($('.summaryDeliveryAddress').data("setDefault"), {addressId: addressId}, function (data) {
                section = ".summaryDeliveryAddress";
                $("#summaryDeliveryAddressBook").html(
                    $.templates(section + ' .colorboxTemplate').render({
                        addresses: data
                    })
                );
            });

        });

        KMVP.masterCarts.bindMoveCartEntryToQuoteRequest();

    },
    validateDeliveryAddressPopUp: function(){
    	$submitButton = $('.js-button-edit-deliveryaddress-save');
        $('#colorbox #deliveryAddressForm').ajaxForm({
           beforeSubmit: function() {
               $submitButton.attr('disabled', true)
               return true;
           },
           success: function(data){
               if($(data).find('#summaryDeliveryAddressForm').length){
                   $submitButton.attr('disabled', false)

                   $('#summaryDeliveryAddressFormWrapper').html($(data).find('#summaryDeliveryAddressForm'));
                   $("#addressDropdownSelect > option").each(function() {
                       if ($(this).attr("data-address") && $(this).attr("data-address") == $("#addressId").val()) {
                           $(this).attr('selected','selected');
                       }
                   });
                   ACC.checkoutB2B.validateDeliveryAddressPopUp();
                   ACC.checkoutB2B.handleInputError();
                   $.colorbox.resize();
               }else{
                   window.location.reload();
               }
           }
        });
    },
    validateBillingAddressPopUp: function(){
        $submitButton = $('.js-button-edit-billingAddress-save');
        $('#colorbox #billingAddressForm').ajaxForm({
            beforeSubmit: function() {
                $submitButton.attr('disabled', true)
                return true;
            },
            success: function(data){
                if($(data).find('#summaryBillingAddressForm').length){
                    $submitButton.attr('disabled', false)

                    $('#summaryBillingAddressFormWrapper').html($(data).find('#summaryBillingAddressForm'));
                    $("#addressDropdownSelect > option").each(function() {
                        if ($(this).attr("data-address") && $(this).attr("data-address") == $("#addressPk").val()) {
                            $(this).attr('selected','selected');
                        }
                    });
                    ACC.checkoutB2B.validateBillingAddressPopUp();
                    $.colorbox.resize();
                }else{
                    window.location.reload();
                }
            }
        });
    },


    deliveryMode: function () {

        $(document).on("click", '#summaryDeliveryModeOverlay .saveButton', function (e) {
            e.preventDefault();
            var setDeliveryModeUrl = $(".summaryDeliveryMode").data("set");
            var selectedCode = $('input:radio[name=delivery]:checked').val();
            if (selectedCode) {
                $.postJSON(setDeliveryModeUrl, {modeCode: selectedCode}, function (data) {
                    ACC.checkoutB2B.refresh(data);
                });
            }
            $.colorbox.close();
        });


        $(document).on("click", '.summaryDeliveryMode .editButton', function () {
            section = ".summaryDeliveryMode";
            $.postJSON($(section).data('get'), function (data) {
                if (ACC.checkoutB2B.cartData.deliveryMode != null)
                    $("#summaryDeliveryModeOverlay").html(
                        $.templates(section + ' .colorboxTemplate').render({
                        data: data,
                        selectedCode: ACC.checkoutB2B.cartData.deliveryMode.code
                        })
                    );
                else
                    $("#summaryDeliveryModeOverlay").html(
                        $.templates(section + ' .colorboxTemplate').render({
                        data: data,
                        selectedCode: 'standard-net'
                        })
                    );
            });

            $.colorbox({
                inline: true,
                href: "#summaryDeliveryModeOverlay",
                height: false,
                overlayClose: false,
                onComplete: function () {
                    ACC.common.refreshScreenReaderBuffer();
                    $.colorbox.resize();
                },
                onClosed: function () {
                    ACC.common.refreshScreenReaderBuffer();
                }
            });

        });
    },
    handleTelephoneNotification: function (section) {
        $(document).on("click", '#telephoneNotification', function () {
            if($("#telephoneNotification").is(':checked')) {
                $(".js-dkg-phonenotification").removeClass("hide");
            } else {
                $(".js-dkg-phonenotification").addClass("hide");
            }
        });

        if ($("#telephoneNotification").length && $("#globalMessages .alert").length > 0) {
            KMVP.individualDelivery.restoreTelAvisData();
        }
    },
    handleCranCostHint: function (section) {
        $(document).on("click", '#order_crane', function () {
            if ($("#telephoneNotification").is(':disabled')) {
                return;
            }
            if($("#order_crane").is(':checked')) {
                $(".js-cran-costs-hint").removeClass("hide");
            } else {
                $(".js-cran-costs-hint").addClass("hide");
            }
        });
    },
    handleEditBillingAddress: function (section) {
        // the billing address edit button event
        $(document).on("click", '.summaryBillingAddress .editButton', function () {
            var openColorBox = function () {
                $.colorbox({
                    inline: true,
                    href: "#summaryBillingAddressOverlay",
                    height: false,
                    innerWidth: "550px",
                    onLoad: function () {
                        $('#cboxClose').remove();
                    },
                    onComplete: function () {
                        ACC.common.refreshScreenReaderBuffer();
                        ACC.checkoutB2B.validateBillingAddressPopUp();
                        $.colorbox.resize();
                    },
                    onClosed: function () {
                        ACC.common.refreshScreenReaderBuffer();
                    }
                });
            };

            // get the billing address change url from form
            var changeFormUrl = $(this).closest(".js-summaryBillingAddress").data('get-form') + "?addressPk=" + $(this).data("address");
            // get the billing address get url from form
            var getUrl = $(this).closest(".js-summaryBillingAddress").data('get');
            ACC.checkoutB2B.showBillingAddressForm(changeFormUrl, getUrl, openColorBox, true);
        });
    },
    displaySection: function (section) {
        var cartData = ACC.checkoutB2B.cartData;

        if ($(".summaryPaymentMode input[name=PaymentMode]:checked").length < 1 && cartData.paymentMode != null) {
            $("#PaymentModeSelection_" + cartData.paymentMode.code).attr("checked", true);
        }

        if (cartData.paymentType.code == "ACCOUNT") { // not used at kloeckner by now
            $(".summaryCostCenter").show();
            $(".summaryPayment").hide();
        } else if (cartData.paymentType.code == "KLOECKNER_STANDARD") {
            $(".summaryCostCenter").hide();
            $(".summaryPayment").hide();
            $(".summaryBillingAddress").show();
        } else { // CARD
            $(".summaryCostCenter").hide();
            $(".summaryPayment").show();
            $(".summaryBillingAddress").show();
        }
    },
    refreshSection: function (section) {
        var cartData = ACC.checkoutB2B.cartData;
        $(section + " .contentSection").html(
            $.templates(section + ' .sectionTemplate').render({
                data: cartData
            })
        );
    },
    refresh: function (data) {
        if (data == undefined) {
            $.postJSON($(".js-checkout-content-panel").data("checkoutCartUrl"), function (data) {
                ACC.checkoutB2B.refreshSections(data);
            });
        }
        else {
            ACC.checkoutB2B.refreshSections(data);
        }
    },
    refreshSections: function (data) {
        ACC.checkoutB2B.cartData = data;
        ACC.checkoutB2B.refreshSection(".summaryPayment");
        ACC.checkoutB2B.refreshSection(".summaryDeliveryAddress");
        ACC.checkoutB2B.refreshSection(".summaryDeliveryMode");
        ACC.checkoutB2B.displaySection();

        KMVP.deliveryInstructions.updateActionSection(data);
    },
    placeOrder: function (data) {
        $(document).on("click", '.js-place-order-button', function (e) {

            if ($("#telephoneNotification").length) {
                $(".js-telavis-contact").removeClass("telavis-label-error");
                $(".js-telavis-phone").removeClass("telavis-label-error");

                var telAvisPerson = $("#orderTelAvis_person").val();
                var telAvisPhone = $("#orderTelAvis_phone").val();
                var regex = /^[0-9 ()+-/]+$/;
                var telAvisPhoneGood = regex.test(telAvisPhone);

                if ($("#telephoneNotification").is(':checked') && (telAvisPerson.trim().length === 0 || telAvisPhone.trim().length === 0 || !telAvisPhoneGood)) {
                    e.preventDefault();

                    if (telAvisPerson.trim().length === 0) {
                        $(".js-telavis-contact").addClass("telavis-label-error");
                        $("#orderTelAvis_error").removeClass("hide");
                    }
                    if (telAvisPhone.trim().length === 0) {
                        $(".js-telavis-phone").addClass("telavis-label-error");
                        $("#orderTelAvis_error").removeClass("hide");
                    }
                    if (!telAvisPhoneGood) {
                        $(".js-telavis-phone").addClass("telavis-label-error");
                        $("#orderTelAvis_invalidPhone_error").removeClass("hide");
                    }

                    return;
                }
                KMVP.individualDelivery.storeDkgTelAvisData();

                if ($("#telephoneNotification").is(':checked')) {
                    $("#telAvisPerson").val(telAvisPerson);
                    $("#telAvisTelephone").val(telAvisPhone);
                    $("#telAvisTimeEnumCode").val($("#orderTelAvis_notificationTime").val());
                }
                if ($("#order_crane").is(':checked')) {
                    $("#deliverWithCrane").val($("#order_crane").is(':checked'));
                }
            }

            if ($(this).hasClass("js-no-buyable-entries-found")) {
                e.preventDefault();

                ACC.address.openAddressPopup();

                return;
            }

            var $this = $(this),
                $form = $this.parents('form'),
                $yourReference = $('.js-note-reference-input'),
                $yourReferenceRequired = $yourReference.data('your-reference-required'),
                $billNote = $('.js-bill-note'),
                $billNoteControlGroup = $billNote.find('.js-your-reference'),
                $billNoteErrorHelpLine = $billNote.find('.help-inline'),
                securityCode = $("#SecurityCodePayment").val();

            $(".securityCodeClass").val(securityCode);

            if ($yourReferenceRequired === true) {
                $yourReference.on('focus', function () {
                    $billNoteErrorHelpLine.addClass('d-none');
                    $billNoteControlGroup.removeClass('error');
                    $(this).off('focus');
                });

                if ($yourReference.val() === '') {
                    $billNoteControlGroup.addClass('error');
                    $billNoteErrorHelpLine.removeClass('d-none');
                } else {
                    $this.prop('disabled', true);
                    $form.submit();
                }
            } else {
                $this.prop('disabled', true);
                $form.submit();
            }
        });
    },

    displayStartDateIssueNum: function () {

        var cardType = $("#cardType").val();

        if (cardType == 'maestro' || cardType == 'switch') {
            $('#startDate, #issueNum').show("fast", 'linear', function () {
                parent.$.colorbox.resize()
            });
        }
        else {
            $('#startDate, #issueNum').hide('fast', 'linear', function () {
                parent.$.colorbox.resize()
            });

        }


    },

    handleInputError: function () {
        $('.create_update_address_form').find('.second-row').each(function () {
            var error = $(this).find('.help-inline').detach();
            error.appendTo($(this).next('.first-row'));
        });
    },

    showAddressForm: function (changeFormUrl, getUrl, openColorBox, checkForPaymentType) {
    	if (checkForPaymentType && ACC.checkoutB2B.cartData.paymentType.code != "ACCOUNT") {
    		$("#summaryDeliveryAddressBook").hide();
    	}
        $.get(changeFormUrl, function (data) {

            $("#summaryDeliveryAddressForm").remove();
            $("#summaryDeliveryAddressOverlay").prepend(data);
            $("#summaryDeliveryAddressForm #defaultDeliveryAddressId").val($("#addressDropdownSelect option:selected").attr("data-address"));

            $.postJSON(getUrl, function (data) {
                section = ".summaryDeliveryAddress";
                $("#summaryDeliveryAddressBook").html(
                    $.templates(section + ' .colorboxTemplate').render({
                    addresses: data,
                    editable: true
                    })
                );

                openColorBox();
            });
        });
    },

    showBillingAddressForm: function (changeFormUrl, getUrl, openColorBox, checkForPaymentType) {
        // get tha billing form page and attach it
        $.get(changeFormUrl, function (data) {

            $("#summaryBillingAddressForm").remove();
            $("#summaryBillingAddressOverlay").prepend(data);

            $.postJSON(getUrl, function (data) {
                openColorBox();
            });
        });
    },
};


$(document).ready(function () {
    if ($("body").hasClass("page-cartPage") || $("body").hasClass("page-contractCart")) {
        $('.js-login-or-checkout-button').click(function (e) {
            if (!KMVP.registration.isLoggedIn()) {
                KMVP.registration.openLogin(e);
            } else if ($(this).hasClass("js-no-buyable-entries-found")) {
                ACC.address.openAddressPopup();
            } else {
                console.log($(this).data("href"));
                window.location = $(this).data("href");
            }
        });
    }

    if ($("body").hasClass("page-singleStepCheckoutSummaryPage") || $("body").hasClass("page-contractSingleStepCheckoutSummaryPage") || ($("body").hasClass("page-quoteCartSingleStepCheckoutSummaryPage") && $('.empty_cart_heading').val() == undefined)) {
        with (ACC.checkoutB2B) {
            refresh();
            PaymentType();
            PaymentMode();
            costCenter();
            payment();
            deliveryAddress();
            deliveryMode();
            handleEditBillingAddress();
            placeOrder();
            handleInputError();
            handleTelephoneNotification();
            handleCranCostHint();
        }
    }
});
